import { createContext } from 'react';
export const AdapterContext = createContext(null);
export const DeviceContext = AdapterContext;
export const ConnectionContext = createContext(null);
